export default {
      id: "plus-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#plus-usage",
      toString: function () {
        return this.url;
      }
    }